import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import SwipeableViews from 'react-swipeable-views'
import { setGoHome, setLoader } from '../action/homeAction'
import { calculateTimeDifference, getDefaultAnalyticsLabel, renderPDFFile } from '../JS/utility'
import { setFailScreen } from '../../action/action'
import { inAppBrowser } from '../JS/inAppBrowser'
import { CLICKED, CMSPath, EXIT } from '../../config/constant'
import { sendAnalytics, getGalleryImages, setGalleryAppData } from '../../action/homeAction'
import { autoPlay } from 'react-swipeable-views-utils';
import $ from 'jquery'
import Panzoom from '@panzoom/panzoom'
import SuccessFailScreen from '../UI/SuccessFailScreen'
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const getFileName = (url) => {
    let len = url.split("/").length
    return url.split("/")[len-1]
}

function GalleryApp(props) {
    let panRefForImageEls = []
    const [currentPage, setCurrentPage] = useState(0)
    const [singleImage, setSingleImage] = useState(false)
    const [widgetLaunchTime, setWidgetLaunchTime] = useState(new Date)
    const [showFailScreen, setFailscreen] = useState({show: false, statusMessage1: "", statusMessage2: ""})
    var timer
    var timeVisible = 5000;
    function timeFadeout() {
        timer = setTimeout(function() {
            $('.img-controls').fadeOut();          
        }, timeVisible );
    }

    const handleChange = (index) => {
        console.log("index", index)
        setCurrentPage(index)
        
        panRefForImageEls.map(obj => {console.log(obj);obj.panzoom.reset(obj.currentValues);obj.panzoom.resetStyle()})
        setTimeout(() => {
            setPanZoom()
        }, 200)
        clearTimeout(timer);
        // if ($('.img-controls:visible').length) {
        //     $('.img-controls').fadeOut();
        // }
        // else {
            $('.img-controls').fadeIn();
            timeFadeout();
        // }
    }

    useEffect(() => {

        if(!props.currentWidget.galleryId){
            let url = `${CMSPath}${props.currentWidget.imageUrl}`
        
            console.log("props.currentWidget.targetUrl",props.currentWidget.imageUrl, url)
            let isPDF = `${props.currentWidget.imageUrl}`.endsWith(".pdf")
            let pdfFileName = isPDF ? getFileName(props.currentWidget.imageUrl) : ""


            if(isPDF){
                if (window.cordova || window.device) {
                    if (window.device.platform === "Android") {
                        props.setLoader(true, "Downloading file ..... Please wait", true)
                        // let url = targetUrlrenderer
                        if(url.toLowerCase().startsWith("https")) {
                            url = url.replace("https", "http")
                            url = url.replace("8443", "8080")
                        }
                        console.log("pdf url", url)
                        renderPDFFile(url, pdfFileName, props.setLoader, props.setFailScreen, () => props.setGoHome(true))
                    } else if(window.device.platform == 'iOS') {
                        inAppBrowser(url,props,false, props.currentWidget)
                        props.setGoHome(true)
                    }
                } else {
                    window.open(url)
                    props.setGoHome(true)
                }
                return;
            } else {
                setSingleImage(true)
                setTimeout(() => {
                    setPanZoom()
                }, 200)
            }
        } else {
            props.setLoader(true, "Loading gallery .... Please wait")
            props.getGalleryImages(props.currentWidget.galleryId, 
                (status) => {
                    if(status) props.setLoader(false, "")
                    else { 
                        props.setLoader(false, "")
                        setFailscreen({show: true, statusMessage1: "Unable to show gallery", statusMessage2: "Failed to load images"})
                    }
                })

        }
        // timeFadeout();

        $('.control-container').click(function() {
            clearTimeout(timer);
            if ($('.img-controls:visible').length) {
                $('.img-controls').fadeOut();
            }
            else {
                $('.img-controls').fadeIn();
                timeFadeout();
            }
        });

        // Send Analytics
        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
        props.sendAnalytics(
            props.guestDetail, 
            props.currentWidget.displayName, 
            CLICKED, 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget"}, 
            0, 
            props.guestIsLoggedIn
        );
        // 

    }, [])

    useEffect(() => {
        return () => {
            props.setGalleryAppData(null) 
            // Send Analytics
            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second')
            let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
            props.sendAnalytics(
                props.guestDetail, 
                props.currentWidget.displayName, 
                EXIT, 
                {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
                0, 
                props.guestIsLoggedIn
            );
            // 
        };
      }, []);

    const handleTryAgain = () => {

    }

    const setPanZoom = () => {
        const elem = document.getElementsByClassName('pinchToZoom')
        for(let i=0; i < elem.length; i++){
            const panzoom = Panzoom(elem[i], {overflow: 'visible', minScale: 0.999, maxScale: 6, panOnlyWhenZoomed: true})
            let currentValues = panzoom.pan(0,0)

            elem[i].parentElement.addEventListener('wheel', panzoom.zoomWithWheel)
            elem[i].addEventListener('panzoomchange', (event) => {
                if(event.detail.scale <= 0.999 )
                panzoom.reset(currentValues)
              })              
            panRefForImageEls.push({"panzoom":panzoom, "currentValues": currentValues})
        }
    }

    useEffect(() => {
        setPanZoom()
    }, [props.galleryAppData])
    
    return (
        <>
            <header class="img-controls inner-pages subpages">
                <a onClick={() => props.setGoHome(true)} class="button-back"></a>
                <div class="heading align-center">
                    <p class="bold" style={{color: '#fff'}}>{props.currentWidget.displayName}</p>
                </div>
            </header>
            {console.log("currentPage",currentPage)}
            <section class="widgets gallery-app padding-0 container-bg">
                <div class="gallery-main">
                    {!(currentPage == 0) && !singleImage && <div class="img-controls nav nav-left" onClick={() => {handleChange(currentPage - 1);console.log("setting next page")}}></div>}
                    {!(props.galleryAppData && props.galleryAppData.multiple.length - 1 == currentPage) && !singleImage && <div class="img-controls nav nav-right" onClick={() => handleChange(currentPage + 1)}></div>}
                    <div class="gallery-tips">Tap screen to toggle show/hide img-controls<br/>Pinch to zoom in/out</div>
                    <div class="control-container gallery-items" style={{overflowX: 'scroll', display: 'flex', alignItems: 'center', backgroundColor: `${props.galleryAppData ? props.galleryAppData.brandingInfo.backgroundColour : "#000"}`}} >
                        {
                            singleImage ? 
                            <SwipeableViews containerStyle={{height: '100vh', display: 'flex', alignItems: 'center'}} animateTransitions={true} //autoPlay={true} interval={props.galleryAppData && props.galleryAppData.brandingInfo.autoSlideTimeInSec * 1000}
                                index={currentPage}
                                disabled={true}
                                onChangeIndex={index => handleChange(index)}>
                                <div className="pinchToZoom"><img src={`${CMSPath}${props.currentWidget.imageUrl}`} /></div>
                            </SwipeableViews>
                            
                            :
                        
                            <SwipeableViews containerStyle={{height: '100vh', display: 'flex', alignItems: 'center'}} animateTransitions={true} //autoPlay={true} interval={props.galleryAppData && props.galleryAppData.brandingInfo.autoSlideTimeInSec * 1000}
                                index={currentPage}
                                // disabled={true}
                                onChangeIndex={index => handleChange(index)}
                                >
                                    {
                                        props.galleryAppData && props.galleryAppData.multiple.map(obj => 
                                            <div class="pinchToZoom"><img src={`${CMSPath}${props.galleryAppData.connectorBaseUrl}${obj.FHD_ImageUrl}`} /></div>
                                        )
                                    }
                                
                                    
                            </SwipeableViews>}
                    </div>
                </div>
                {showFailScreen.show && <SuccessFailScreen statusMessage1={showFailScreen.statusMessage1} statusMessage2={showFailScreen.statusMessage2} showTryAgain={true} showClose={true} tryAgain={handleTryAgain} close={() => props.setGoHome(true)} />}
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        serviceUnavailable : state.store2.serviceUnavailable,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidget: state.store.sideNavBar.currentWidget,
        survey: state.store.survey,
        currentHomePage: state.store2.currentHomePage,
        galleryAppData: state.store2.galleryAppData,
        CheckedInGuest: state.store.CheckedInGuest,
    }
}

export default connect(mapStateToProps, {setGoHome, setFailScreen, setLoader, sendAnalytics, getGalleryImages, setGalleryAppData})(GalleryApp);

{/* <img class="pinchToZoom" src="https://cdn.pixabay.com/photo/2020/06/01/22/23/eye-5248678__340.jpg" />
                            <img class="pinchToZoom" src="https://miro.medium.com/max/1200/1*mk1-6aYaf_Bes1E3Imhc0A.jpeg" /> */}